
import React from 'react';
import {TableBody} from 'material-ui';
import TableLanguagesInputs from './TableLanguagesInputs';

const TableSitesInputs = ({
    classes, 
    sites, 
    languages, 
    sitesLanguages, 
    changeSiteLanguage
}) => (
    <TableBody>
        {sites.map(site =>
            <TableLanguagesInputs
                key={site.id}
                languages={languages}
                sitesLanguages={sitesLanguages}
                changeSiteLanguage={changeSiteLanguage}
                site={site}
                classes={classes}
            />
        )}
    </TableBody>
)

export default TableSitesInputs;


// WEBPACK FOOTER //
// ./src/containers/configuration/forms/TableSitesInputs.jsx